const { badges, badgeHierarchyOrder } = GM_STATE.customs
const { lowStockThreshold } = GM_STATE.cart
const lowStockBadge = {
  type: 'custom',
  label: 'low stock'
}

const customOrderBadge = badgeHierarchyOrder
  .toLowerCase()
  .split(',')
  .map((item) => item.trim())

const badgeOrderMap = new Map(customOrderBadge.map((label, index) => [label, index]))

const handleCustomBadge = (tags) => {
  const { enable, prefix } = badges.custom

  if (!enable || !prefix || !tags?.length) return []

  return tags
    .filter((tag) => tag.startsWith(prefix))
    .map((tag) => ({
      type: 'custom',
      label: tag.replace(new RegExp(`^${prefix}|-`, 'g'), ' ').trim()
    }))
}

const getBadges = (product, currentVariant, max) => {
  const { tags, variants } = product
  const variantQuantity = currentVariant?.inventory_quantity || variants[0]?.inventory_quantity || 0
  const badgeList = []
  const customBadges = handleCustomBadge(tags)

  if (variantQuantity > 0 && variantQuantity <= lowStockThreshold) {
    badgeList.push(lowStockBadge)
  }

  badgeList.push(...customBadges)

  badgeList.sort((a, b) => {
    const indexA = badgeOrderMap.get(a.label) ?? Infinity
    const indexB = badgeOrderMap.get(b.label) ?? Infinity

    return indexA - indexB
  })

  return badgeList.slice(0, max)
}

export default getBadges
